import { useAuth } from "../context/AuthContext";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import headcoin from "../Image/head.png";
import tailcoin from "../Image/tail.png";
import circle from "../Image/line.png";
import stage from "../Image/stage.png";
import coin from "../Image/head.png";
import winner from "../Image/gameWinImg.png";
import looser from "../Image/gameLoseImg.png";
import { useForm } from "react-hook-form";
import bitcoin from "../Image/bitcoin.png";

function Coinflip({ setOpenLogin, isAuth }) {
  const [isFlip, setIsFlip] = useState(false);
  const [selectCoin, setSelectCoin] = useState("");
  const [filp, setFlip] = useState(0);
  const [coinResult, setCoinResult] = useState(headcoin);
  const [gameResult, setGameResult] = useState(null);
  const [tableData, setTableData] = useState([]);
  const { wallet, setWallet } = useAuth();
  const [isHeads, setIsHeads] = useState(true);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("CoingameData")) || [];

    setTableData(storedData);

    const loadWallet = () => {
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};

      setWallet(currentUser?.wallet ? parseFloat(currentUser.wallet) : 0);
    };

    loadWallet();
  }, [isAuth, setWallet]);

  const coinFlip = (data) => {
    const betAmount = parseFloat(data.amount);
    if (!selectCoin) {
      toast.warning("Please Select a Coin");
      return;
    }

    if (betAmount <= 0) {
      toast.error("Enter amount greater than 0");
      return;
    }

    if (Number(data.amount) > wallet) {
      toast.error("Insufficient Wallet Balance");
      return;
    }

    if (isFlip) return;
    setIsFlip(true);
    setGameResult(null);

    const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};

    setTimeout(() => {
      const randomResult = Math.random() < 0.5 ? "head" : "tail";
      setIsHeads(randomResult === "head");
      setIsFlip(false);

      let finalResult = "";
      let finalWallet = wallet;

      if (selectCoin === randomResult) {
        finalResult = "winner";
        setGameResult("winner");
        finalWallet = wallet + betAmount * 2;
      } else {
        finalResult = "looser";
        setGameResult("looser");
        finalWallet = wallet - betAmount;
      }
      setWallet(finalWallet);
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
      currentUser.wallet = finalWallet;
      localStorage.setItem("currentUser", JSON.stringify(currentUser));

      const users = JSON.parse(localStorage.getItem("user")) || [];
      const updatedUsers = users.map((user) => {
        if (user.email === currentUser.email) {
          return { ...user, wallet: finalWallet };
        }

        return user;
      });

      localStorage.setItem("user", JSON.stringify(updatedUsers));

      localStorage.setItem(
        "currentUser",
        JSON.stringify({ ...currentUser, wallet: finalWallet }),
      );

      const newGameData = {
        email: currentUser?.email || "Guest",
        selectCoin: selectCoin,
        betAmount: betAmount,
        winAmount: finalResult === "winner" ? betAmount * 2 : 0,
        gameResult: finalResult,
      };

      setTableData((prev) => {
        const updatedData = [...prev, newGameData];
        localStorage.setItem("CoingameData", JSON.stringify(updatedData));
        return updatedData;
      });
      reset();
    }, 3000);
  };

  return (
    <div className="dicegame-section">
      <div className="container">
        <div className="dicegame-wrapper">
          {gameResult && (
            <div className="result-popup">
              <img
                src={gameResult === "winner" ? winner : looser}
                alt={gameResult}
                className="result-status-img"
              />
              <button onClick={() => setGameResult(null)}>Close</button>
            </div>
          )}
          <form
            onSubmit={
              isAuth
                ? handleSubmit(coinFlip)
                : (e) => {
                    e.preventDefault();
                    setOpenLogin(true);
                  }
            }
          >
            <div className="coingame-wrapper-inner">
              <div className="dicegame-card">
                <div className="d-flex justify-content-center align-items-center gap-2">
                  <img
                    src={headcoin}
                    alt="headCoin"
                    className={`coinimg ${selectCoin === "head" ? "selected" : ""}`}
                    onClick={() => setSelectCoin("head")}
                  />
                  <img
                    src={tailcoin}
                    alt="tailCoin"
                    className={`coinimg ${selectCoin === "tail" ? "selected" : ""}`}
                    onClick={() => setSelectCoin("tail")}
                  />
                </div>
                
                <div className="amount-field mt-3">
                  <div className="bet-input-wrapper d-flex align-items-center">
                    <div className="d-flex align-items-center">
                      <img src={bitcoin} alt="bitcoin" height={24} />
                    </div>

                    <input
                      type="number"
                      step="any"
                      placeholder="Enter Your Bet Amount"
                      className="amount-input"
                      {...register("amount", {
                        required: "Amount is required",
                        validate: (value) =>
                          parseFloat(value) > 0 ||
                          "Amount must be greater than 0",
                      })}
                    />
                  </div>

                  {errors.amount && (
                    <p className="error-text">{errors.amount.message}</p>
                  )}
                </div>
              </div>

              <button type="submit" className="coin-btn" disabled={isFlip}>
                {!isAuth ? "LOGIN TO PLAY" : isFlip ? "FLIP..." : "COIN FLIP"}
              </button>
            </div>
          </form>

          <div className="coingame-bg">
            <div className="coingame-bg-inner">
              <img src={circle} alt="circle" className="circle" />
              <img src={stage} alt="stage" className="stageimg" />

              <div
                className={`coin-container 
              ${!isHeads ? "show-tail" : ""} 
              ${isFlip ? "flipping-animation" : ""}`}
              >
                <img
                  src={headcoin}
                  alt="head"
                  className="coin-face front-face"
                />
                <img
                  src={tailcoin}
                  alt="tail"
                  className="coin-face back-face"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="gametable-responsive-wrapper">
          <table className="game-table mt-3">
            <thead>
              <tr>
                <th>Player Email</th>
                <th>Selected Coins</th>
                <th>Amount Bets</th>
                <th>Win Amount</th>
                <th>Result</th>
              </tr>
            </thead>
            <tbody>
              {tableData.length > 0 ? (
                tableData.map((gameitem, index) => (
                  <tr key={index}>
                    <td>{gameitem.email}</td>
                    <td>{gameitem.selectCoin}</td>
                    <td>{gameitem.betAmount}</td>
                    <td>{gameitem.winAmount ? gameitem.winAmount : "-"}</td>

                    <td>
                      {gameitem.gameResult === "winner" ? "Winner" : "Looser"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center" }}>
                    No Game Played Yet
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Coinflip;
